var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.41,
    height: 14.41,
    viewBox: "0 0 14.41 14.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_44757",
    "data-name": "Group 44757",
    transform: "translate(-834 -167.333)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-my-location",
    "data-name": "Icon material-my-location",
    d: "M8.538,5.918a2.62,2.62,0,1,0,2.62,2.62A2.619,2.619,0,0,0,8.538,5.918Zm5.856,1.965a5.891,5.891,0,0,0-5.2-5.2V1.333H7.883V2.683a5.891,5.891,0,0,0-5.2,5.2H1.333v1.31H2.683a5.891,5.891,0,0,0,5.2,5.2v1.349h1.31V14.394a5.891,5.891,0,0,0,5.2-5.2h1.349V7.883H14.394Zm-5.856,5.24a4.585,4.585,0,1,1,4.585-4.585,4.582,4.582,0,0,1-4.585,4.585Z",
    transform: "translate(832.667 166)",
    fill: "#06d6a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocated);
export default __webpack_public_path__ + "static/media/located.6d172d0af97e3974756edae1976c6e20.svg";
export { ForwardRef as ReactComponent };